/* eslint-disable @angular-eslint/directive-selector */
import { Directive, ElementRef, inject, Input, Renderer2 } from "@angular/core"

export type AgTextStyle =
  | "title-1"
  | "title-2"
  | "title-3"
  | "title-4"
  | "title-5"
  | "title-6"
  | "featured-1"
  | "featured-1-medium"
  | "featured-1-semibold"
  | "featured-2"
  | "featured-2-medium"
  | "featured-2-semibold"
  | "featured-3"
  | "featured-3-medium"
  | "featured-3-semibold"
  | "body-1"
  | "body-1-medium"
  | "body-1-semibold"
  | "body-2"
  | "body-2-medium"
  | "body-2-semibold"
  | "body-3"
  | "body-3-medium"
  | "body-3-semibold"
  | "caption-1"
  | "caption-1-medium"
  | "caption-1-semibold"
  | "caption-2"
  | "caption-2-medium"
  | "caption-2-semibold"

@Directive({ selector: "[agText]", standalone: false })
export class AgTextDirective {
  private el = inject<ElementRef<HTMLElement>>(ElementRef)
  private renderer = inject(Renderer2)

  private currentClass = ""

  @Input() set agText(style: AgTextStyle | "") {
    if (this.currentClass) this.renderer.removeClass(this.el.nativeElement, this.currentClass)
    if (style) this.renderer.addClass(this.el.nativeElement, style)
    this.currentClass = style
  }
}
